import $ from 'jquery';

export default class MeganavMenu {
  constructor(el) {
    this.$el = $(el);

    this.$el.on('click.meganav-menu', '.meganav-menu-header', event => {
      const $header = $(event.currentTarget);

      if (!$header.hasClass('meganav-menu-empty') && !$header.hasClass('navmenu-link-meganav')) {
        this.toggleList($header);
      }
    });

    this.$el.on('click.meganav-menu', '.navmenu-arrow-toggle', event => {
      event.preventDefault();
      event.stopPropagation();

      const $header = $(event.currentTarget);
      this.arrowToggle($header);
    });
  }

  unload() {
    this.$el.off('.meganav-menu');
  }

  toggleList($header, state) {
    const $group = $header.parents('.meganav-menu-group');

    if ($group.hasClass('meganav-menu-active')) {
      return true;
    } else {
      event.preventDefault();
      const $list = $group.find('.meganav-menu-items');
      $group.toggleClass('meganav-menu-active', state);
      $list.slideToggle(state);
    }
  }

  arrowToggle($header, state) {
    const $group = $header.parents('.meganav-menu-group');
    const $list = $group.find('.meganav-menu-items');
    $group.toggleClass('meganav-menu-active', state);
    $list.slideToggle(state);
  }
}
